@if (deviceService.isMobilePhone) {
    <div class="generic-modal-wrapper">
        <div class="generic-modal-content-wrapper">
            <div [vnElementKey]="VanillaElements.QUICK_DEPOSIT_WRAPPER" class="player-quickdeposit-v2">
                <div class="player-quickdeposit-content-loading-v2">
                    <qd-feature />
                </div>
            </div>
        </div>
    </div>
} @else {
    <div [vnElementKey]="VanillaElements.QUICK_DEPOSIT_WRAPPER" class="player-quickdeposit quickdeposit-v2">
        <div class="player-quickdeposit-content-loading">
            <qd-feature />
        </div>
    </div>
}
